import { connect } from "react-redux";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import momentPropTypes from "react-moment-proptypes";
import FloatingActionButton from "material-ui/FloatingActionButton";
import ActionCode from "material-ui/svg-icons/action/code";
import OperatorSelectionSidebarContainer from "../../target-node-impc-selector/containers/OperatorSelectionSidebarContainer";
import ProgressButtons from "./ProgressButtons";
import {
  getArrivalCheckedOperator,
  getArrivalOperators,
  getDepartureCheckedOperator,
  getDepartureOperators,
  getDirections,
  getExpandedArrivalPostalOperators,
  getExpandedDeparturePostalOperators,
  getIsDirectionsSwitched,
  getSelectedArrivalOperators,
  getSelectedDepartureOperators,
  getTrafficCheckedOperator,
  getTrafficOperatorNodes,
} from "../../target-node-impc-selector/redux/selectors/PostalOperatorSelectors";
import SaveIMPCSelectionModal from "../../target-node-impc-selector/components/SaveIMPCSelectionModal";
import { saveUserOperatorSelectionRequestActionCreator } from "../../../user/redux/actions/UserActions";
import PostalOperatorSelector from "../../target-node-impc-selector/components/PostalOperatorSelector";
import {
  getPeriodSelectorEndDate,
  getPeriodSelectorStartDate,
} from "../../period-selector/redux/selectors/PeriodSelectionSelectors";
import {
  departureMailProcessingCenterCheckedActionCreator,
  onDeparturePostalOperatorExpanded,
  onDeSelectAllDepartureOperators,
  onSelectAllDepartureOperators,
  retrieveOutboundPostalOperatorsRequestActionCreator,
} from "../../target-node-impc-selector/redux/actions/DeparturePostalOperatorActions";
import {
  arrivalMailProcessingCenterCheckedActionCreator,
  onArrivalPostalOperatorExpanded,
  onDeSelectAllOperators,
  onSelectAllArrivalOperators,
  retrieveInboundPostalOperatorsRequestActionCreator,
} from "../../target-node-impc-selector/redux/actions/ArrivalPostalOperatorActions";
import {
  setDirectionFlag,
  setDirections,
  switchDepartureArrival,
} from "../../target-node-impc-selector/redux/actions/PostalOperatorActions";
import {
  onDeSelectAllTrafficOperators,
  onSelectAllTrafficOperators,
  trafficOperatorsCheckedActionCreator,
} from "../../target-node-impc-selector/redux/actions/TrafficOperatorActions";
import OperatorTypes from "../../../common/redux/actions/types/OperatorTypes";
import * as LocationTypes from "../../../common/redux/actions/types/LocationTypes";
import sc from "../../../common/redux/actions/types/SelectionCriteriaTypes";
import scDefinitions from "../../../common/config/SelectionCriteriaDefinitions";
import DirectionTypes from "../../../common/redux/actions/types/DirectionTypes";
import noop from "../../../../core/modules/common/tools/noop";
import CheckboxTreeSelector from "../../../common/components/CheckboxTreeSelector";

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      retrieveOutboundPostalOperatorsRequestActionCreator,
      retrieveInboundPostalOperatorsRequestActionCreator,
      saveUserOperatorSelectionRequestActionCreator,
      departureMailProcessingCenterCheckedActionCreator,
      onDeparturePostalOperatorExpanded,
      onSelectAllDepartureOperators,
      onDeSelectAllDepartureOperators,
      arrivalMailProcessingCenterCheckedActionCreator,
      onArrivalPostalOperatorExpanded,
      onSelectAllArrivalOperators,
      onDeSelectAllOperators,
      setDirections,
      switchDepartureArrival,
      getIsDirectionsSwitched,
      setDirectionFlag,
      trafficOperatorsCheckedActionCreator,
      onSelectAllTrafficOperators,
      onDeSelectAllTrafficOperators,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  selectedDepartureOperatorsNodes: getSelectedDepartureOperators(state),
  departureOperatorNodes: getDepartureOperators(state),
  departureCheckedOperators: getDepartureCheckedOperator(state),
  departureExpandedPostalOperators: getExpandedDeparturePostalOperators(state),
  selectedArrivalOperatorsNodes: getSelectedArrivalOperators(state),
  arrivalOperatorsNodes: getArrivalOperators(state),
  arrivalCheckedOperators: getArrivalCheckedOperator(state),
  arrivalExpandedPostalOperators: getExpandedArrivalPostalOperators(state),
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
  directions: getDirections(state),
  isDirectionsSwitched: getIsDirectionsSwitched(state),
  trafficOperatorsNodes: getTrafficOperatorNodes(state),
  trafficCheckedOperators: getTrafficCheckedOperator(state),
});

// eslint-disable-next-line react/prefer-stateless-function
class TargetNodeOperatorWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstDeparture: true,
      firstArrival: true,
      departureSelectionTreeLoaded: false,
      arrivalSelectionTreeLoaded: false,
      showOnlySelectedDeparturePostalOperators: false,
      showOnlySelectedArrivalPostalOperators: false,
      showSaveSelectionModal: false,
      saveSelectionCheckedMailProcessingCenters: [],
      saveSelectionSelections: [],
    };
  }

  componentDidMount() {
    this.props.setDirections({
      directions: this.props.children.report.reportDirections,
    });

    this.props.retrieveOutboundPostalOperatorsRequestActionCreator(
      {
        defaultDirection: this.getDefaultDirection(),
        startDate: this.props.startDate,
        endDate: this.props.endDate,
      },
      this.props.children.report,
      this.props.departureCheckedOperators
    );

    if (this.hasArrivalSelection()) {
      this.props.retrieveInboundPostalOperatorsRequestActionCreator(
        {
          defaultDirection: this.getDefaultDirection(),
          startDate: this.props.startDate,
          endDate: this.props.endDate,
        },
        this.props.children.report,
        this.props.arrivalCheckedOperators
      );
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.props.selectedDepartureOperatorsNodes;

    // eslint-disable-next-line max-len
    if (
      this.state.firstDeparture &&
      this.props.departureOperatorNodes === nextProps.departureOperatorNodes &&
      nextProps.selectedDepartureOperatorsNodes.length !== 0
    ) {
      this.setState({
        firstDeparture: false,
        showOnlySelectedDeparturePostalOperators: true,
      });
    }

    await this.props.selectedArrivalOperatorsNodes;
    // eslint-disable-next-line max-len
    if (
      this.state.firstArrival &&
      this.props.arrivalOperatorsNodes === nextProps.arrivalOperatorsNodes &&
      nextProps.selectedArrivalOperatorsNodes.length !== 0
    ) {
      this.setState({
        firstArrival: false,
        showOnlySelectedArrivalPostalOperators: true,
      });
    }

    await this.props.departureOperatorNodes;
    this.setState({
      departureSelectionTreeLoaded:
        this.props.departureOperatorNodes.length > 0,
    });

    await this.props.arrivalOperatorsNodes;
    this.setState({
      arrivalSelectionTreeLoaded: this.props.arrivalOperatorsNodes.length > 0,
    });
  }

  onSelectAllDeparturePostalOperators = () => {
    this.props.onSelectAllDepartureOperators(this.props.departureOperatorNodes);
  };

  onSelectAllArrivalPostalOperators = () => {
    this.props.onSelectAllArrivalOperators(this.props.arrivalOperatorsNodes);
  };

  onDeSelectAllDeparturePostalOperators = () => {
    this.setState({
      showOnlySelectedDeparturePostalOperators: false,
    });
    this.props.onDeSelectAllDepartureOperators();
  };

  onDeSelectAllArrivalPostalOperators = () => {
    this.setState({
      showOnlySelectedArrivalPostalOperators: false,
    });
    this.props.onDeSelectAllOperators();
  };

  onSelectDeparturePostalOperator = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedDeparturePostalOperators: false,
      });
    } else {
      this.setState({
        firstDeparture: false,
      });
    }
    this.props.departureMailProcessingCenterCheckedActionCreator(
      selected,
      this.props.children.report
    );
  };

  onSelectArrivalPostalOperator = (selected) => {
    if (selected.length === 0) {
      this.setState({
        showOnlySelectedArrivalPostalOperators: false,
      });
    } else {
      this.setState({
        firstArrival: false,
      });
    }
    this.props.arrivalMailProcessingCenterCheckedActionCreator(
      selected,
      this.props.children.report
    );
  };

  onExpandDeparturePostalOperator = (expanded) => {
    this.props.onDeparturePostalOperatorExpanded(expanded);
  };

  onExpandArrivalPostalOperator = (expanded) => {
    this.props.onArrivalPostalOperatorExpanded(expanded);
  };

  onToggleShowOnlySelectedDeparturePostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators:
        !this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  onToggleShowOnlySelectedArrivalPostalOperators = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators:
        !this.state.showOnlySelectedArrivalPostalOperators,
    });
  };

  onSwitchInboundOutbound = () => {
    this.props.setDirectionFlag({
      switched: !this.props.isDirectionsSwitched,
    });
    this.props.switchDepartureArrival({
      departure: {
        checkedOperator: this.props.departureCheckedOperators,
        expandedPostalOperators: this.props.departureExpandedPostalOperators,
        nodesForOperator: this.props.departureOperatorNodes,
      },
      arrival: {
        checkedOperator: this.props.arrivalCheckedOperators,
        expandedPostalOperators: this.props.arrivalExpandedPostalOperators,
        nodesForOperator: this.props.arrivalOperatorsNodes,
      },
    });
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedDeparturePostalOperators:
        this.state.showOnlySelectedArrivalPostalOperators,
      // eslint-disable-next-line react/no-access-state-in-setstate
      showOnlySelectedArrivalPostalOperators:
        this.state.showOnlySelectedDeparturePostalOperators,
    });
  };

  getScCode = () => {
    const selectionCriteria =
      this.props.children.report.selectionCriteria.items;
    let scCode = sc.SC010;
    if (selectionCriteria.indexOf(sc.SC011) > -1) {
      scCode = sc.SC011;
    } else if (selectionCriteria.indexOf(sc.SC011NA) > -1) {
      scCode = sc.SC011NA;
    } else if (selectionCriteria.indexOf(sc.SC011T) > -1) {
      scCode = sc.SC011T;
    }

    return scCode;
  };

  getDefaultDirection() {
    let defaultDirection = this.props.children.report.reportDirections[0];
    if (this.props.isDirectionsSwitched) {
      defaultDirection =
        defaultDirection === DirectionTypes.INBOUND
          ? DirectionTypes.OUTBOUND
          : DirectionTypes.INBOUND;
    }
    return defaultDirection;
  }

  hasArrivalSelection = () =>
    this.getScCode() === sc.SC011T ? false : this.getScCode() !== sc.SC011NA;

  hasTrafficSelection = () => this.getScCode() === sc.SC011T;

  openSaveSelectionModalForDeparture = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: this.props.departureCheckedOperators,
      selections: this.props.departureSelections,
    });
  };

  openSaveSelectionModalForArrival = () => {
    this.openSaveSelectionModal({
      checkedMailProcessingCenters: this.props.arrivalCheckedOperators,
      selections: this.props.arrivalSelections,
    });
  };

  openSaveSelectionModal = ({ checkedMailProcessingCenters, selections }) => {
    this.setState({
      showSaveSelectionModal: true,
      saveSelectionCheckedMailProcessingCenters: checkedMailProcessingCenters,
      saveSelectionSelections: selections,
    });
  };

  closeSaveSelectionModal = () => {
    this.setState({
      showSaveSelectionModal: false,
    });
  };

  saveSelection = ({ name, checkedMailProcessingCenters }) => {
    this.props.saveUserOperatorSelectionRequestActionCreator(
      name,
      checkedMailProcessingCenters
    );
    this.closeSaveSelectionModal();
  };

  onSelectTrafficOperators = (selected) => {
    this.props.trafficOperatorsCheckedActionCreator(
      selected,
      this.props.children.report
    );
  };

  onDeselectAllTrafficOperators = () => {
    this.props.onDeSelectAllTrafficOperators();
  };
  onSelectAllTrafficOperators = () => {
    this.props.onSelectAllTrafficOperators(this.props.trafficOperatorsNodes);
  };

  render() {
    const tempDepartureNodes = [
      {
        value: "DUMMY",
        label: "LOADING...",
        expandDisabled: true,
        children:
          this.props.departureCheckedOperators &&
          this.props.departureCheckedOperators.length > 0
            ? this.props.departureCheckedOperators.map((initialItem) => ({
                value: initialItem,
                label: "",
              }))
            : [],
      },
    ];
    const tempArrivalNodes = [
      {
        value: "DUMMY",
        label: "LOADING...",
        expandDisabled: true,
        children:
          this.props.arrivalCheckedOperators &&
          this.props.arrivalCheckedOperators.length > 0
            ? this.props.arrivalCheckedOperators.map((initialItem) => ({
                value: initialItem,
                label: "",
              }))
            : [],
      },
    ];

    const departurePostalOperatorSelectorProps = {
      selected: this.props.departureCheckedOperators,
      expanded: !this.state.departureSelectionTreeLoaded
        ? []
        : this.props.departureExpandedPostalOperators,
      expandDisabled: !this.state.departureSelectionTreeLoaded
        ? true
        : this.props.children.report.locationType === LocationTypes.OPERATOR,
      isShowOnlySelected: !this.state.departureSelectionTreeLoaded
        ? true
        : this.state.showOnlySelectedDeparturePostalOperators,
      // eslint-disable-next-line no-nested-ternary
      postalOperatorNodes: !this.state.departureSelectionTreeLoaded
        ? tempDepartureNodes
        : this.state.showOnlySelectedDeparturePostalOperators
        ? this.props.selectedDepartureOperatorsNodes
        : this.props.departureOperatorNodes,
      onSelect: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onSelectDeparturePostalOperator,
      onExpand: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onExpandDeparturePostalOperator,
      onSelectAll: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onSelectAllDeparturePostalOperators,
      onDeSelectAll: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onDeSelectAllDeparturePostalOperators,
      onShowOnlySelected: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.onToggleShowOnlySelectedDeparturePostalOperators,
      openSaveSelectionModal: !this.state.departureSelectionTreeLoaded
        ? noop
        : this.openSaveSelectionModalForDeparture,
    };

    const arrivalPostalOperatorSelectorProps = {
      selected: this.props.arrivalCheckedOperators,
      expanded: !this.state.arrivalSelectionTreeLoaded
        ? []
        : this.props.arrivalExpandedPostalOperators,
      expandDisabled: !this.state.arrivalSelectionTreeLoaded
        ? true
        : this.props.children.report.locationType === LocationTypes.OPERATOR,
      isShowOnlySelected: !this.state.arrivalSelectionTreeLoaded
        ? true
        : this.state.showOnlySelectedArrivalPostalOperators,
      // eslint-disable-next-line no-nested-ternary
      postalOperatorNodes: !this.state.arrivalSelectionTreeLoaded
        ? tempArrivalNodes
        : this.state.showOnlySelectedArrivalPostalOperators
        ? this.props.selectedArrivalOperatorsNodes
        : this.props.arrivalOperatorsNodes,
      onSelect: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onSelectArrivalPostalOperator,
      onExpand: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onExpandArrivalPostalOperator,
      onSelectAll: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onSelectAllArrivalPostalOperators,
      onDeSelectAll: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onDeSelectAllArrivalPostalOperators,
      onShowOnlySelected: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.onToggleShowOnlySelectedArrivalPostalOperators,
      openSaveSelectionModal: !this.state.arrivalSelectionTreeLoaded
        ? noop
        : this.openSaveSelectionModalForArrival,
    };

    const trafficOperators = {
      selected: this.props.trafficCheckedOperators,
      nodes: this.props.trafficOperatorsNodes,
      onSelect: this.onSelectTrafficOperators,
      onSelectAll: this.onSelectAllTrafficOperators,
      onDeSelectAll: this.onDeselectAllTrafficOperators,
      expandDisabled: true,
      isShowOnlySelected: false,
      originalNodes: [],
    };

    const selectionCriteria =
      this.props.children.report.selectionCriteria.items;
    const SC_CODE = this.getScCode();
    const nextSelectionCriteriaRouteName = (
      scDefinitions[
        selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]
      ] || {}
    ).routeName;
    /* eslint-disable react/jsx-indent */

    return (
      <div className="operator-selector-wrapper">
        {this.state.showSaveSelectionModal && (
          <SaveIMPCSelectionModal
            saveSelection={this.saveSelection}
            closeModal={this.closeSaveSelectionModal}
            checkedMailProcessingCenters={
              this.state.saveSelectionCheckedMailProcessingCenters
            }
            selections={this.state.saveSelectionSelections}
          />
        )}
        <div className="operator-sidebar">
          <OperatorSelectionSidebarContainer
            operatorType={OperatorTypes.DEPARTURE}
            report={this.props.children.report}
          />
        </div>

        <div className="operators">
          <div className="operators-selection-panel">
            <div className="operator">
              <PostalOperatorSelector
                title="DEPARTURE OPERATOR"
                {...departurePostalOperatorSelectorProps}
              />
            </div>
            {this.props.directions.directionSwitchEnabled &&
              this.hasArrivalSelection() && (
                <div className="operator-divider">
                  <FloatingActionButton
                    onClick={this.onSwitchInboundOutbound}
                    backgroundColor="#03adaa"
                    mini
                    style={{
                      zIndex: 1,
                      marginLeft: "-20px",
                      marginTop: "11px",
                      border: "5px solid #abe1e5",
                      boxShadow: "none",
                    }}
                  >
                    <ActionCode />
                  </FloatingActionButton>
                </div>
              )}
            {this.hasArrivalSelection() && (
              <div className="operator">
                <PostalOperatorSelector
                  title="ARRIVAL OPERATOR"
                  {...arrivalPostalOperatorSelectorProps}
                />
              </div>
            )}

            {this.hasTrafficSelection() && (
              <>
                <div className="operator-divider" />
                <div className="operator">
                  <div className="operator-selector-container">
                    <CheckboxTreeSelector
                      title="TRAFFIC"
                      {...trafficOperators}
                    />
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="actions">
            <ProgressButtons
              next={this.props.children.routes[nextSelectionCriteriaRouteName]}
            />
          </div>
        </div>

        {this.hasArrivalSelection() && (
          <div className="operator-sidebar">
            <OperatorSelectionSidebarContainer
              operatorType={OperatorTypes.ARRIVAL}
              report={this.props.children.report}
            />
          </div>
        )}
      </div>
    );
  }
}

TargetNodeOperatorWizardContainer.propTypes = {
  report: PropTypes.shape({
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  retrieveOutboundPostalOperatorsRequestActionCreator: PropTypes.func,
  retrieveInboundPostalOperatorsRequestActionCreator: PropTypes.func,
  selectedDepartureOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  departureOperatorNodes: PropTypes.arrayOf(PropTypes.object),
  departureCheckedOperators: PropTypes.arrayOf(PropTypes.string),
  departureExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  departureSelections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
  selectedArrivalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalOperatorsNodes: PropTypes.arrayOf(PropTypes.object),
  arrivalCheckedOperators: PropTypes.arrayOf(PropTypes.string),
  arrivalExpandedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  arrivalSelections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
  saveUserOperatorSelectionRequestActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onDeparturePostalOperatorExpanded: PropTypes.func,
  onSelectAllDepartureOperators: PropTypes.func,
  onDeSelectAllDepartureOperators: PropTypes.func,
  arrivalMailProcessingCenterCheckedActionCreator: PropTypes.func,
  onArrivalPostalOperatorExpanded: PropTypes.func,
  onSelectAllArrivalOperators: PropTypes.func,
  onDeSelectAllOperators: PropTypes.func,
  directions: PropTypes.shape({
    defaultDirection: PropTypes.string,
    directionSwitchEnabled: PropTypes.bool,
    switched: PropTypes.bool,
  }),
  setDirections: PropTypes.func,
  isDirectionsSwitched: PropTypes.bool,
  switchDepartureArrival: PropTypes.func,
  setDirectionFlag: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  startDate: momentPropTypes.momentObj,
  // eslint-disable-next-line react/no-typos
  endDate: momentPropTypes.momentObj,
  /* eslint-enable react/no-typos */
  trafficOperatorsCheckedActionCreator: PropTypes.func,
  onSelectAllTrafficOperators: PropTypes.func,
  onDeSelectAllTrafficOperators: PropTypes.func,
  trafficCheckedOperators: PropTypes.arrayOf(PropTypes.string),
};

/* Needed for prop-types with cloneElement */
export const ConnectedTargetNodeOperatorWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TargetNodeOperatorWizardContainer);

export default ConnectedTargetNodeOperatorWizardContainer;
